// Modules
import React from "react";

const OvenIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<path d="M271,296a8,8,0,0,0-16,0c0,4.994-1.89,7.154-5.021,10.732C246.19,311.062,241,316.994,241,328s5.19,16.938,8.979,21.268C253.11,352.846,255,355.006,255,360a8,8,0,0,0,16,0c0-11.006-5.19-16.938-8.979-21.268C258.89,335.154,257,332.994,257,328s1.89-7.154,5.021-10.732C265.81,312.938,271,307.006,271,296Z" />
				<path d="M319,296a8,8,0,0,0-16,0c0,4.994-1.89,7.154-5.021,10.732C294.19,311.062,289,316.994,289,328s5.19,16.938,8.979,21.268C301.11,352.846,303,355.006,303,360a8,8,0,0,0,16,0c0-11.006-5.19-16.938-8.979-21.268C306.89,335.154,305,332.994,305,328s1.89-7.154,5.021-10.732C313.81,312.938,319,307.006,319,296Z" />
				<path d="M223,296a8,8,0,0,0-16,0c0,4.994-1.89,7.154-5.021,10.732C198.19,311.062,193,316.994,193,328s5.19,16.938,8.979,21.268C205.11,352.846,207,355.006,207,360a8,8,0,0,0,16,0c0-11.006-5.19-16.938-8.979-21.268C210.89,335.154,209,332.994,209,328s1.89-7.154,5.021-10.732C217.81,312.938,223,307.006,223,296Z" />
				<path d="M440,144H72a8,8,0,0,0-8,8V440a8,8,0,0,0,8,8H440a8,8,0,0,0,8-8V152A8,8,0,0,0,440,144Zm-8,288H80V160H432Z" />
				<path d="M452,16H60A44.049,44.049,0,0,0,16,60V452a44.049,44.049,0,0,0,44,44H452a44.049,44.049,0,0,0,44-44V60A44.049,44.049,0,0,0,452,16ZM32,60A28.032,28.032,0,0,1,60,32H452a28.032,28.032,0,0,1,28,28V96H32ZM452,480H60a28.032,28.032,0,0,1-28-28V112H480V452A28.032,28.032,0,0,1,452,480Z" />
				<path d="M312,40H200a8,8,0,0,0-8,8V80a8,8,0,0,0,8,8H312a8,8,0,0,0,8-8V48A8,8,0,0,0,312,40Zm-8,32H208V56h96Z" />
				<path d="M120,256H392a24,24,0,0,0,8-46.624V184a8,8,0,0,0-8-8H360a8,8,0,0,0-8,8v24H160V184a8,8,0,0,0-8-8H120a8,8,0,0,0-8,8v25.376A24,24,0,0,0,120,256Zm248-64h16v16H368Zm-240,0h16v16H128Zm-8,32H392a8,8,0,0,1,0,16H120a8,8,0,0,1,0-16Z" />
				<path d="M152,40a24,24,0,1,0,24,24A24.027,24.027,0,0,0,152,40Zm0,32a8,8,0,1,1,8-8A8.009,8.009,0,0,1,152,72Z" />
				<path d="M88,40a24,24,0,1,0,24,24A24.027,24.027,0,0,0,88,40Zm0,32a8,8,0,1,1,8-8A8.009,8.009,0,0,1,88,72Z" />
				<path d="M424,40a24,24,0,1,0,24,24A24.027,24.027,0,0,0,424,40Zm0,32a8,8,0,1,1,8-8A8.009,8.009,0,0,1,424,72Z" />
				<path d="M360,40a24,24,0,1,0,24,24A24.027,24.027,0,0,0,360,40Zm0,32a8,8,0,1,1,8-8A8.009,8.009,0,0,1,360,72Z" />
				<path d="M328,400H184a8,8,0,0,0,0,16H328a8,8,0,0,0,0-16Z" />
				<path d="M368,400h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z" />
			</g>
		</svg>
	);
};

export default OvenIcon;
